import styled from "@emotion/styled"
import Arrow from "../../assets/icons/circle-arrow.svg"
import { css } from "@emotion/react"
import { Typography } from "@mui/material"

const arrowStyle = theme => css`
  circle {
    stroke: ${theme.palette.primary.light};
    transition: 0.3s all ease-in-out;
  }
  path {
    fill: ${theme.palette.primary.light};
    transition: 0.3s all ease-in-out;
  }
`

export const ArrowsContainer = styled.div`
  display: flex;
  align-items: center;
  &.dark {
    margin-top: 2.5rem;
    justify-content: center;
    svg path {
      fill: ${({ theme }) => theme.palette.text.content};
    }
    circle {
      stroke: ${({ theme }) => theme.palette.text.content};
    }
    p {
      color: ${({ theme }) => theme.palette.text.content};
    }
  }
  /* &.black {
    circle {
      stroke: ${({ theme }) => theme.palette.primary.light};
      opacity: 0.6;
    }
    path {
      fill: ${({ theme }) => theme.palette.primary.light};
      opacity: 0.6;
    }
  } */

  /* &.black {
    .MuiIconButton-root {
      &:hover {
        svg {
          circle {
            stroke: ${({ theme }) => theme.palette.primary.light};
            opacity: 1;
          }
          path {
            fill: ${({ theme }) => theme.palette.primary.light};
            opacity: 1;
          }
        }
      }
    }
  } */

  .MuiIconButton-root {
    &:hover {
      svg {
        circle {
          opacity: 0.8;
        }
        path {
          opacity: 0.8;
        }
      }
    }
  }
`

export const LeftArrow = styled(Arrow)`
  ${({ theme }) => arrowStyle(theme)};
  transform: rotate(180deg);
`
export const RightArrow = styled(Arrow)`
  ${({ theme }) => arrowStyle(theme)};
`

export const Number = styled(Typography)`
  color: ${({ theme }) => theme.palette.text.light};
  text-align: center;
  font-size: ${({ theme }) => theme.typography.pxToRem("17")};
  line-height: normal;
  height: 100%;
  display: flex;
  align-items: center;
  padding: 0 4px;
`
